import { ManagerProperties } from './ManagerProperties';
import { UsersProperties } from './UsersProperties';
import { ActiveAgencies, B2BActiveBranches, ActiveCurrencies, ActiveLanguages, ActiveAgenciesTypes, Agency_Branches, ActiveAgencyGroups } from './ActiveClasses';
import { AgencyRightsProperties } from './AgencyRightsProperties';
import { AgencySupplierRightsdata, AgencySupplierRightsProperties } from './SuppliersProperties';
import { BranchInformationProperties } from './BranchInformationProperties';
export class AgencyMasterProperties {
  agencyId: string = "";
  agencyName: string = "";
  status: boolean = false;
  emailAddress: string = "";
  notificationEmail: string = "";
  agencyType: number = 0;
  address1: string = "";
  address2: string = "";
  country: string = null;
  city: string = "";
  zip: string = "";
  currency: number = 0;
  language: number = 0;
  mobileContact: string = "";
  telephoneNumber: string = "";
  fax: string = "";
  maximumUsers: number ;
  maximumChildAgencies: number=0;
  maximumChildBranches: number=0 ;
  managerName: string = "";
  managerEmailAddress: string = "";
  managerPhone: string = "";
  settlementMode: number = 0;
  creditLimit: number = 0;
  logoFileName: string = "";
  logoFilePath: string = "";
  imageFile: string = "";
  creationDate: string = "";
  creationUser: number = 0;
  modifyDate: string = "";
  modifyUser: number = 0
  parentAgency: string = "";
  agencyLevel: number = 0;
  backSystemCustomerId: string = "";
  immediateParent: string = "";
  isMasterAgency: boolean = false;
  groupId: string = "";
  agencyColourCode: string = "";
  managers: ManagerProperties[] = [];
  userObj = new UsersProperties();
  agencyRightObj = new AgencyRightsProperties();
  agencySupplierList: AgencySupplierRightsProperties[] = [];
  pendingcreditLimit: number = 0;
  isAlreadyActive: boolean = false;
  backCompanyId: number = 0;
}


export class AgencyBaseDataProperties {
  agencies: Agency_Branches[] = [];
  languages: ActiveLanguages[] = [];
  currencies: ActiveCurrencies[] = [];
  agencyTypes: ActiveAgenciesTypes[] = [];
  agencyGroups: ActiveAgencyGroups[] = [];
}

export class Agencies_BranchesProperties {
  code: string = "";
  name: string = "";
  country: string = "";
  email: string = "";
  status: boolean = false;
  labelName: string = "";
  backSystemCompanyName: string = "";
  creationDate: string = "";
}
export class AgencyBranchCreditProperties {
  agencyMasterProp: AgencyMasterProperties[] = [];
  branchInfoProp: BranchInformationProperties[] = [];
}
export class ManagerDetailsProperties {
  managerName: string = "";
  managerEmailAddress: string = "";
  managerPhone: string = "";
}
export class AgencyBranchDataProperties {
  agencyId: string = "";
  agencyName: string = "";
  creditLimit: number = 0;
  pendingCreditLimit: number = 0;
}
export class AgencyBranchApprovalProperties {
  agencyId: string = "";
  accountNumber: string = "";
  amount: number = 0;
  paymentId: number = 0;

}

export class ReportTypesAgency {
  status: boolean;
  reportTypes: string;
  reportId: number;
  reportRightId: number;
  statusForUser: boolean;
  requestStatus: boolean = false;
}
export class ReportTypesUser {
  status: boolean;
  reportTypes: string;
  reportId: number;
  reportRightId: number;
  statusForUser: boolean;
  requestStatus: boolean ;

}
export class AgencyListBaseData {
  currencies: ActiveCurrencies[] = [];
  languages: ActiveLanguages[] = [];
  agencyManagement: boolean;
  branchManagement: boolean;
  canAddOrEditAgency: boolean;
}
export class agencyBackFromServerProperties {
  agencyId: string;
  message: string;
  isSave: boolean;
  managers: ManagerProperties[] = [];
}
export class CustomerCodes {
  customerCode: string = "";
  customerName: string = "";
}
export class UrlRequest {
  request: string = "";
}
export class CreditLimitChecking {
  returnCredit: number = 0;
  returnPendingCredit: number = 0;
}
export class AgenciesForManagers {
  agencyId: string;
  agencyName: string;
}
export class AddNewManagers {
  userId: number[] = [];
  agencyIds: string[] = [];
  managerName: string[] = [];
  managerEmailAddress: string;
  managerPhone: string;
  creationUser: number = 0;
}

export class SupplierRightsForAgencyAndBranchProperties {
  supplierOfficeIdsCounter: number = 0;
  supplierId: string = "";
  supplierStatus:boolean=false;
  supplierName:string="";
  agency_Branch: string = "";
  createUser: number;
  supplierBoolean:SupplierRightsForAgencyAndBranchBooleanProperties[]=[];
  suppliersOfficeIds: SuppliersOfficeIds[] = [];
  supplierTypeId: number = 0;
  
}
export class SupplierRightsForAgencyAndBranchBooleanProperties {
  supplierOficeId: string;
  canBook: boolean ;
  canIssue: boolean ;
  canRefund: boolean ;
  canVoid: boolean;
  canSearch: boolean ;
}
export class SuppliersOfficeIds{
  officeIds:string;
}
export class BackSystemCreditRequest{
  companyURL:string;
  companyCustomer:string;

}
export class BackSystemCreditLimitProperties{
  creditLimit:number;
  creditOutstanding:number;

}

